export const caseStudyArray = [
  {
    id: 'siemens',
    name: 'Siemens',
    link: '/case-study/siemens',
    img: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '',
    category: '',
    customerName: '',
    location: '',
    year: 0,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description: ''
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  },
  {
    id: 'sapna-online',
    name: 'Sapna Online',
    link: '/case-study/sapna-online',
    img: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '',
    category: '',
    customerName: '',
    location: '',
    year: 0,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description: ''
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  },
  {
    id: 'letsshave',
    name: 'LetsShave',
    link: '/case-study/letsshave',
    img: '/images/case-study/letsshave.jpg',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '',
    category: 'E-Commerce',
    customerName: '',
    location: '',
    year: 0,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description: ''
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  },
  {
    id: 'grofers',
    name: 'Grofers',
    link: '/case-study/grofers',
    img: '/images/case-study/grofers.jpg',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '/images/case-study/grofers-banner.jpg',
    category: 'E-Commerce',
    customerName: '90 Minutes India Pvt Ltd.',
    location: 'Gurgaon, Haryana',
    year: 2016,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description:
        '<p>Grofers started in December 2013 as a hyper local delivery for fruits and vegetables. The idea was to become the largest online grocery store that catered to the busy urban population of India at low prices. The goal was to solve the discrepancies in the existing system and scale up quickly.</p>'
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  },
  {
    id: 'dainik-bhaskar',
    name: 'Dainik Bhaskar',
    link: '/case-study/dainik-bhaskar',
    img: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '',
    category: '',
    customerName: '',
    location: '',
    year: 0,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description: ''
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  },
  {
    id: 'cosmetize',
    name: 'Cosmetize',
    link: '/case-study/cosmetize',
    img: '',
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dolor gravida nisl fringilla nec arcu est. Penatibus imperdiet id elit nec, odio in tristique. Et ac integer dignissim nec. Eget vitae pulvinar neque eu cras. Velit turpis justo, tellus, in. Egestas phasellus etiam sed.....',
    bannerImg: '',
    category: 'E-Commerce',
    customerName: '',
    location: 'United Kingdom',
    year: 0,
    overView: {
      labelText: 'About',
      title: 'Overview',
      description: ''
    },
    content: {
      menu: [
        {
          name: 'Overview',
          link: '#overview'
        },
        {
          name: 'Situation',
          link: '#situation'
        },
        {
          name: 'Solution',
          link: '#solution'
        },
        {
          name: 'Outcome',
          link: '#outcome'
        }
      ],
      blocks: [
        {
          id: 'situation',
          labelText: 'About',
          title: 'Situation',
          description: [
            {
              textOnly:
                '<p>Grofers were doing good business and had just received its first round of funding from Sequoia Capital. We were invited to their HQ office in Gurugram to study the work process and solve the discrepancies on the technology side. Our analysis found some serious issues in system coordination process:</p>',
              list: {
                type: 'decimal',
                data: [
                  'Delivery hub used to get the notification of the new order. The delivery boy used to reach unaware of the order',
                  'Stock updates were unavailable in fulfilment hubs. If any product was out of stock the delivery executive had to run to another fulfilment hub and collect the order causing waste of time',
                  'The invoice was manually generated once the order was ready to be delivered'
                ]
              },
              img: ''
            }
          ]
        },
        {
          id: 'solution',
          labelText: 'Idea',
          title: 'Solution',
          description: [
            {
              title: 'Bridging the points',
              textOnly:
                '<p>By integrating the APIs with the mobile app, we were ready to have a pilot run. We ran the pilot on 3 fulfilment hubs in Gurugram. Fulfilment hubs along with the delivery hub were notified as the order was placed. As a result:</p>',
              list: {
                type: 'disc',
                data: [
                  'By the time delivery executive reached the fulfilment hub the order was ready to be dispatched.',
                  'Saving 20 minutes of time, at least on each delivery.'
                ]
              }
            },
            {
              title: 'Effectively managing the inventory',
              textOnly:
                '<p>Inventory plays an important part in the business. Grofers was scaling up the business model, but as they had no updates about the inventory it was pulling them back. We automated their inventory system. Outcome of this was:</p>',
              list: {
                type: 'disc',
                data: [
                  'When an order is placed, if the item is out of stock the delivery hub is routed to another hub.',
                  'It gave visibility on the inventory.',
                  'Last but not least, scalability was achieved faster than anticipated.'
                ]
              },
              img: ''
            },
            {
              title: 'Minimizing the human intervention',
              textOnly:
                '<p>The final invoice was created by fulfilment hubs, with 100s of orders delivered in the peak hours it was getting difficult to generate invoices manually and accurately on time. For this a flexible invoicing system was customized that helped Grofers manage all the complex invoices, such as automatic invoice generation and multiple invoices at a time with 100% accuracy.</p>'
            },
            {
              title: 'Scaling up',
              textOnly:
                '<p>The success of the pilot run gave us a license to scale up and move to the next phase; that was implementing the software in groceries and other categories. Implementation of the software was done in all 5 fulfilment hubs. Management of 1000+ SPUs and inventories were done in this phase.</p>' +
                '<p>After seeing the positive results, Grofers went ahead and implemented the software in 150+ fulfilment hubs across the country.</p>',
              img: ''
            }
          ]
        },
        {
          id: 'outcome',
          labelText: 'Idea',
          title: 'Outcome',
          description: [
            {
              textOnly:
                '<p>Grofers were able to manage 10,000+ orders in a day with a small team of just 5 people. The technology enchantment helped them save 20 minutes on each delivery, this led to reach more people in less time.</p>'
            }
          ]
        }
      ]
    }
  }
];
